import React from 'react'
import { CenteredContent } from 'containers'
import { AllocationsList } from './'
import Typography from '@material-ui/core/Typography'

export default function AllAllocations(props){
  return (
    <CenteredContent>
      <Typography variant="h5">Allocations</Typography>
      <AllocationsList/>
    </CenteredContent>
  )
}